export default __webpack_public_path__ + "static/media/icon-inventory.6cde215a.svg";